//External modules
import React from 'react';
import { useStoreState } from 'easy-peasy';

// Internal modules
import { features } from '@/lib';
import { DateOfBirth } from './DateOfBirth';
import { Gender } from './Gender';
import { IdentityDocumentNumber } from './IdentityDocumentNumber';
import { IdentityDocumentType } from './IdentityDocumentType';
import { Nationality } from './Nationality';
import { Occupation } from './Occupation';
import { PlaceOfBirth } from './PlaceOfBirth';
import { SecondaryIdentityDocumentNumber } from './SecondaryIdentityDocumentNumber';
import { SecondaryIdentityDocumentType } from './SecondaryIdentityDocumentType';
import { CountryOfResidence } from './CountryOfResidence';

const nameToComponent = {
  CountryOfResidence: CountryOfResidence,
  DateOfBirth: DateOfBirth,
  Gender: Gender,
  IdentityDocumentNumber: IdentityDocumentNumber,
  IdentityDocumentType: IdentityDocumentType,
  Nationality: Nationality,
  Occupation: Occupation,
  PlaceOfBirth: PlaceOfBirth,
  SecondaryIdentityDocumentNumber: SecondaryIdentityDocumentNumber,
  SecondaryIdentityDocumentType: SecondaryIdentityDocumentType,
};

const KYCFields = props => {
  const fiType = useStoreState(({ ui }) => ui.fiType);
  const { value: countryOfResidence } =
    useStoreState(({ form }) => form.countryOfResidence) || {};
  const cardFieldsToDisplay = useStoreState(({ ui }) => ui.cardFieldsToDisplay);

  // Exclude any KYC fields that are displayed earlier
  // in the page before signup fields
  const kycFields = features.config.kycFields.filter(field => {
    switch (field) {
      case 'DateOfBirth':
        return fiType !== 'bank' && !cardFieldsToDisplay.dob;
      case 'IdentityDocumentType':
        return features.config.kycIdTypes.length > 1;
      case 'SecondaryIdentityDocumentNumber':
        return countryOfResidence === 'RU';
      case 'SecondaryIdentityDocumentType':
        return countryOfResidence === 'RU';
      default:
        return true;
    }
  });

  return kycFields.map(fieldName => {
    const Field = nameToComponent[fieldName];
    return <Field {...props} key={fieldName} />;
  });
};

export { KYCFields };
